import { useEffect, useState } from "react";
import { Quote } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "I walked in barely able to lift my arm — six weeks later I'm back to swimming. Their patience and precision changed everything.",
    name: "Priya R.",
    detail: "Frozen shoulder · Mylapore",
  },
  {
    quote:
      "Post-ACL recovery felt overwhelming until I found Revive Ripple. The plan was honest, structured and surprisingly kind.",
    name: "Karthik S.",
    detail: "ACL rehab · Adyar",
  },
  {
    quote:
      "After years of chronic back pain, this is the first place that didn't just chase symptoms. They listened, and it worked.",
    name: "Mrs. Lakshmi V.",
    detail: "Chronic back pain · T. Nagar",
  },
  {
    quote:
      "Warm space, sharp expertise. My mother's stroke recovery has been steady and dignified — exactly what we needed.",
    name: "Anand K.",
    detail: "Neuro rehabilitation",
  },
];

const MARQUEE = [
  "Hands-on care",
  "Personalised plans",
  "Evidence-based",
  "Mylapore, Chennai",
  "Open Mon — Sat",
  "Home visits available",
];

export default function Testimonials() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setI((v) => (v + 1) % REVIEWS.length),
      6500
    );
    return () => clearInterval(t);
  }, []);

  const r = REVIEWS[i];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-forest-900 text-sand-50 py-16 md:py-32 lg:py-40 overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-40 -right-40 w-[600px] h-[600px] opacity-[0.08]">
        <div className="w-full h-full ripple-deco" style={{ filter: "invert(1)" }} />
      </div>

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-12 gap-8 items-start">
          <div className="col-span-12 md:col-span-4">
            <span className="inline-flex items-center gap-3 text-xs tracking-[0.28em] uppercase text-sand-50/70">
              <span className="w-10 h-px bg-terracotta-500" />
              Patient stories
            </span>
            <h2 className="mt-5 font-serif text-5xl md:text-6xl leading-[1.02] tracking-tight">
              Words from
              <br />
              <em className="text-terracotta-500">our people.</em>
            </h2>
            <div className="mt-10 flex items-center gap-3">
              {REVIEWS.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setI(idx)}
                  data-testid={`testimonial-dot-${idx}`}
                  aria-label={`Show testimonial ${idx + 1}`}
                  className={`h-1.5 rounded-full transition-all ${
                    i === idx
                      ? "w-10 bg-terracotta-500"
                      : "w-5 bg-sand-50/30 hover:bg-sand-50/60"
                  }`}
                />
              ))}
            </div>
          </div>

          <div
            className="col-span-12 md:col-span-8 md:pl-12 relative"
            data-testid="testimonial-active"
          >
            <Quote
              size={64}
              strokeWidth={1.25}
              className="text-terracotta-500/80 mb-6"
            />
            <blockquote
              key={i}
              className="font-serif italic text-3xl md:text-4xl lg:text-5xl leading-[1.15] text-sand-50 animate-fade-up"
            >
              "{r.quote}"
            </blockquote>
            <div className="mt-10 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-terracotta-500/20 border border-terracotta-500/40 flex items-center justify-center font-serif text-xl">
                {r.name.charAt(0)}
              </div>
              <div>
                <p className="font-serif text-xl">{r.name}</p>
                <p className="text-xs tracking-[0.24em] uppercase text-sand-50/65 mt-1">
                  {r.detail}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Marquee strip */}
        <div className="mt-24 md:mt-32 -mx-6 md:-mx-12 lg:-mx-20 border-t border-sand-50/15 pt-10 overflow-hidden">
          <div className="flex gap-12 whitespace-nowrap animate-marquee">
            {[...MARQUEE, ...MARQUEE, ...MARQUEE].map((t, idx) => (
              <span
                key={idx}
                className="font-serif text-3xl md:text-4xl italic text-sand-50/85 inline-flex items-center gap-12"
              >
                {t}
                <span className="w-2 h-2 rounded-full bg-terracotta-500" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
